import { ReactComponent } from './money-xxl.svg';

export const MoneyIconXxl = ReactComponent;

export default ReactComponent;
